import script from "./powerStationVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationVideo.vue?vue&type=script&setup=true&lang=js"

import "./powerStationVideo.vue?vue&type=style&index=0&id=27239d34&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27239d34"]])

export default __exports__